import v5_Model from '@/models/v5/model';

var Invite = v5_Model.extend({
    initialize: function() {
        this.type = Invite.type;
    },
    accept: function() {
        var options = {};
        options = {
            data: {
                type: this.type,
                id: this.id,
                attributes: { accepted: true }
            }
        };
        return this.save(options, {patch: true});
    },
    decline: function() {
        var options = {};
        options = {
            data: {
                type: this.type,
                id: this.id,
                attributes: { accepted: false }
            }
        };
        return this.save(options, {patch: true});
    }
});

Invite.type = 'invite';

export default Invite;

